import {hashHistory} from "react-router";

import store from "../store";
import * as types from "../actions/actionTypes";
import {
  hideUserPopup,
  changeMessageBoxState,
} from "../actions/actionFunctions";
import {
  setAfterContractSignCallback
} from "../actions/contractsActions";
import {loaderDisable, loaderEnable} from "../bvcomponents/ui/loaderView";
import JsonApi from "./jsonApi";
import {IS_OFFLINE_MODE} from "../config";
import {shouldUseContractSigning} from "../bvcomponents/popups/contractSign/contractsFunctions";
import {ROUTES} from "../routes";

const _checkNetworkErrorMessage = (message) => {
  // includes, because it can be "Network Error" or "Server Error: Error: Network Error"
  return message && (message === "Network Error" || (message.includes && message.includes("Network Error"))
    || (message.message && message.message.includes("Network Error"))) && IS_OFFLINE_MODE
}

/**
 * renderErrorPopup can display retry connection and sign contract buttons
 * @param message {string}
 * @param title {string}
 * @param retryConnectionFunction {function}
 * @param showContractSignOnError {boolean}
 * @param closeButtonCallback {function}
 * @param afterContractSignCallback {function}
 */
export const renderErrorPopup = (message,
                                 title = "messageBox.defaultTitle",
                                 retryConnectionFunction = null,
                                 showContractSignOnError = false,
                                 closeButtonCallback = null,
                                 afterContractSignCallback = null) => {
  if (_checkNetworkErrorMessage(message)) {
    message = "noInternetText";
    title = "noInternetTitle";
  }
  const closeMessageBox = () => {
    store.dispatch(changeMessageBoxState({
      visible: false,
    }));
  }
  const buttons = [{
    text:  message === "noInternetText" ? "messageBox.closeButton" : "messageBox.buttonOk",
    color:  message === "noInternetText" ? "blue" : "red",
    click: () => {
      closeMessageBox();
      if (closeButtonCallback) {
        closeButtonCallback()
      }
    }
  }];
  if (message === "noInternetText") {
    if (showContractSignOnError) {
      const {fabricatorState, contractSigningState} = store.getState();
      const needContractSignDocument = IS_OFFLINE_MODE
        && shouldUseContractSigning(fabricatorState.settings, contractSigningState.contractsList);
      if (needContractSignDocument) {
        buttons.push({
          text: "messageBox.fillContract",
          color: "green",
          click: () => {
            closeMessageBox();
            // store.dispatch(showContractSigning(true, () => {}));
            if (afterContractSignCallback) {
              store.dispatch(setAfterContractSignCallback(afterContractSignCallback))
            }
            hashHistory.push(ROUTES.contract);
          }
        })
      }
    }
    if (retryConnectionFunction) {
      buttons.push({
        text: "messageBox.retryConnection",
        color: "green",
        click: () => {
          closeMessageBox();
          retryConnectionFunction();
        }
      })
    }
  }
  store.dispatch({
    type: types.CHANGE_MESSAGE_BOX,
    payload: {
      visible: true,
      title,
      message,
      error: message !== "noInternetText",
      newStyles: true,
      buttons
    }
  });
};

export const renderMessagePopup = (message) => {
  let title = "messageBox.defaultTitle";
  if (_checkNetworkErrorMessage(message)) {
    message = "noInternetText";
    title = "noInternetTitle";
  }
  store.dispatch({
    type: types.CHANGE_MESSAGE_BOX,
    payload: {
      visible: true,
      title,
      message,
      error: false,
      inline: false,
      buttons: [{
        text: "messageBox.buttonOk",
        color: "blue",
        click: () => {
          store.dispatch({
            type: types.CHANGE_MESSAGE_BOX,
            payload: {
              visible: false,
            }
          });
        }
      }]
    }
  });
};

export const renderAccountNotActivatedErrorPopup = (message, email) => {
  store.dispatch({
    type: types.CHANGE_MESSAGE_BOX,
    payload: {
      visible: true,
      message,
      error: true,
      inline: false,
      buttons: [{
        text: "userPopup.messageBox.resendActivationEmailText",
        color: "green",
        click: () => {
          store.dispatch(hideUserPopup());
          loaderEnable("loader.resendActivationLinkText");
          JsonApi.resendActivationEmail(email)
            .then(() => {
              loaderDisable();
              renderMessagePopup("userPopup.messageBox.resendActivationEmailSuccess");
            });
        }
      }, {
        text: "messageBox.buttonOk",
        color: "red",
        click: () => {
          store.dispatch(hideUserPopup());
        }
      }]
    }
  })
};

export const renderConfirmPopup = (confirmPopupType, tag, confirmPopupOpened = true) => {
  store.dispatch({
    type: types.TOGGLE_CONFIRM_POPUP,
    payload: {
      confirmPopupOpened,
      confirmPopupType,
      confirmPopupTag: {...tag}
    }
  });
};
